import Checkbox from 'components/Widget/CheckboxItem';
import Select from 'components/Widget/Select';
import { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setSettings, setSettingsModalVisible } from 'redux/mode/actions';
import { DarkModeBehavior } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import Modal from '..';
import * as S from './styles';

const SettingsModal = () => {
	const dispatch = useDispatch();

	const { darkModeBehavior, connectingLinesEnabled, figmaIntegrationEnabled } = useSelector(
		(r: RootReducer) => ({
			darkModeBehavior: r.mode.settings.darkModeBehavior,
			connectingLinesEnabled: r.mode.settings.connectingLinesEnabled,
			figmaIntegrationEnabled: r.mode.settings.figmaIntegrationEnabled,
		}),
		shallowEqual
	);

	const close = useCallback(() => {
		dispatch(setSettingsModalVisible(false));
	}, [dispatch]);

	// when command , is pressed, close modal
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.metaKey && event.key === ',') {
				event.preventDefault();
				close();
			}
		};
		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [close]);

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	const renderDropdown = (
		value: string,
		onChange: (value: any) => void,
		options: Array<{ value: string; label: string }>,
		label: string
	) => {
		return (
			<S.Setting>
				<S.Spacer />
				<S.Choice>
					<S.DropdownContainer>
						<Select maxWidth={130} onChange={onChange} value={value}>
							{options.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Select>
					</S.DropdownContainer>
				</S.Choice>
				<S.Label>{label}</S.Label>
			</S.Setting>
		);
	};

	const renderCheckbox = (checked: boolean, onToggle: () => void, label: string) => {
		return (
			<S.Setting>
				<S.Spacer />
				<S.Choice>
					<S.CheckboxContainer>
						<Checkbox width={16} height={16} checked={checked} onToggled={onToggle} />
					</S.CheckboxContainer>
				</S.Choice>
				<S.Label onClick={onToggle}>{label}</S.Label>
			</S.Setting>
		);
	};

	return (
		<Modal title="Preferences" cancelLabel="Close" submitLabel="Save" onClose={close}>
			<S.Content>
				{renderDropdown(
					darkModeBehavior,
					(event: any) =>
						dispatch(setSettings({ darkModeBehavior: event.target.value as DarkModeBehavior })),
					Object.values(DarkModeBehavior).map((behavior) => ({
						value: behavior,
						label: behavior,
					})),
					'Dark mode behavior'
				)}
				{renderCheckbox(
					connectingLinesEnabled,
					() => dispatch(setSettings({ connectingLinesEnabled: !connectingLinesEnabled })),
					'Connecting lines'
				)}
				{renderCheckbox(
					figmaIntegrationEnabled,
					() => dispatch(setSettings({ figmaIntegrationEnabled: !figmaIntegrationEnabled })),
					'Figma integration (experimental)'
				)}
			</S.Content>
		</Modal>
	);
};

export default SettingsModal;
